import { Redirect, useLocalSearchParams } from 'expo-router'

import { FraternityJoinScreen } from '@/src/features/fraternity/ui/screens/FraternityJoinScreen'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'

const CommunityJoinFraternityRouterPage = () => {
  const searchParams = useLocalSearchParams()
  const { idSlug } = filterSearchParams<TIdSlugParam>(searchParams)

  if (!idSlug) return <Redirect href="not-found" />

  return <FraternityJoinScreen idSlug={idSlug} searchParams={searchParams} />
}

export default CommunityJoinFraternityRouterPage
